module.exports = __webpack_public_path__ + "static/img/Curry.7e683e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Curry.png
// module id = /PJ2
// module chunks = 34